module.exports = __webpack_public_path__ + "img/trend_down.aa9aced6.svg";